import { WorkspaceLimitsDc, ProjectsWithDeps } from "@evergis/api";

import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { isCopyCurrentProject as isCopyCurrentProjectSelector } from "../../../../../../ducks/dialogs/selectors";
import { useProjectInfo } from "../../../../../../ducks/project/hooks";

import { useCheckLimits } from "../../../../../../hooks/useCheckLimits";
import { layerInfosWithDeps } from "../../../../../../resources/layers";

interface CopyProjectPropsResponse {
  limits: WorkspaceLimitsDc | undefined;
  isCopyCurrentProject: boolean;
  actualDeps: ProjectsWithDeps["deps"];
}

export const useCopyProjectProps = (): CopyProjectPropsResponse => {
  const { limits, refetch } = useCheckLimits();
  const isCopyCurrentProject = useSelector(isCopyCurrentProjectSelector);
  const [currentProjectInfo] = useProjectInfo();
  const { items } = currentProjectInfo.content || {};
  const currentLayerNames: string[] = useMemo(() => items && items.map(value => value.name), [items]);
  const { data: layersWithDeps } = layerInfosWithDeps.use({ input: currentLayerNames, waitInput: true });
  const [actualDeps, setActualDeps] = useState<ProjectsWithDeps["deps"]>({
    layers: [],
    tables: [],
  });

  useEffect(() => {
    if (isCopyCurrentProject && limits) {
      refetch();
    }
  }, []);

  useEffect(() => {
    if (!layersWithDeps) {
      return;
    }

    if (isCopyCurrentProject) {
      setActualDeps({
        layers: layersWithDeps.layers,
        tables: layersWithDeps.deps ? layersWithDeps.deps.tables : [],
      });
    }
  }, [isCopyCurrentProject, layersWithDeps]);

  return {
    limits,
    isCopyCurrentProject,
    actualDeps,
  };
};
